import script from "./inbox-section-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./inbox-section-panel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__